import { render } from "./SearchBar.vue?vue&type=template&id=29bc10af&scoped=true&ts=true"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=29bc10af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bc10af"],['__file',"src/lib/components/header/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29bc10af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29bc10af', __exports__)) {
    api.reload('29bc10af', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=29bc10af&scoped=true&ts=true", () => {
    api.rerender('29bc10af', render)
  })

}


export default __exports__